export default function toLocaleCurrency(value) {
  return parseFloat(value.replace('.', '').replace(',', '.'));
}
